import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import {
  listNotifications,
  markAsRead,
  clearNotification
} from '../api/notifications';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const { user } = useAuth();
  // IMPORTANT: we key off the same userId you use when creating notifications
  const userId = user?.attributes?.sub;

  const [notifications, setNotifications] = useState([]);

  const refresh = async () => {
    if (!userId) return;
    const items = await listNotifications(userId);
    setNotifications(items);
  };

  useEffect(() => {
    refresh();
  }, [userId]);

  const readOne = async (notificationId) => {
    if (!userId) return;
    await markAsRead(userId, notificationId);
    await refresh();
  };

  const clearOne = async (notificationId) => {
    if (!userId) return;
    await clearNotification(userId, notificationId);
    await refresh();
  };

  return (
    <NotificationContext.Provider
      value={{ notifications, refresh, readOne, clearOne }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationContext);
}
